module.exports = __webpack_public_path__ + "static/media/loader.36fdd64e.svg";